import React from 'react';
import PropTypes from 'prop-types';
import ParallaxImage from '../../../UI/ImageTreatment/ParallaxImage';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import { Animated } from 'react-animated-css';
import 'animate.css/animate.min.css';
import '../../../UI/Typography/Typography.css';
import './ValuesCarousel.css';
import serviceSmall from './images/slide-image-1-small-min.jpg';
import serviceBig from './images/slide-image-1-large-min-2.jpeg';
import innovationSmall from './images/slide-image-2-small-min-new.jpg';
import innovationBig from './images/slide-image-2-large-min-new.jpg';

import inspirationSmall from './images/slide-image-3-small-min-2.jpeg';
import inspirationBig from './images/service-girl-standing.jpg';

import ownershipSmall from './images/slide-image-4-small-min-new.jpg';
import ownershipBig from './images/slide-image-5-large-min.jpg';


import agilitySmall from './images/slide-image-5-small-min-new.jpg';
import agilityBig from './images/slide-image-4-large-min-new.jpg';

import collaborationSmall from './images/collaboration-meeting.jpg';
import collaborationBig from './images/collaboration-coffee-people.jpg';
import perspectiveSmall from './images/perspective-man-window.jpg';
import perspectiveBig from './images/perspective-man-couch.jpg';
import peopleSmall from './images/people-house.jpg';
import peopleBig from './images/people-group.jpg';
import integritySmall from './images/integrity-people.jpg';
import integrityBig from './images/integrity-laptop.jpg';



// react-animated-css computes the CSS prefix from window, so its styles differ between the server
// and the browser; render a plain wrapper until the component is mounted on the client
const ClientAnimated = ({ isMounted, children, ...props }) => (
    isMounted ? <Animated {...props}>{children}</Animated> : <div>{children}</div>
);

ClientAnimated.propTypes = {
    isMounted: PropTypes.bool,
    children: PropTypes.node,
};

class ValuesCarousel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sidebarLeft: null,
            rightBlock: null,
            isVisible: true,
            isMounted: false,
        };
    }

    componentDidMount() {
        // The server can't evaluate the responsive breakpoint (nor the animation CSS prefix), so both
        // sliders are remounted after mounting; link them once the final instances exist
        this.setState({ isMounted: true }, () => {
            this.setState({
                sidebarLeft: this.slider1,
                rightBlock: this.slider2,
            });
        });
    }

    beforeAnimation() {
        this.setState({ isVisible: false });
    }

    afterAnimation() {
        this.setState({ isVisible: true });
    }

    onHoverHandler = (e) => {
        if (this.props.isDesktop) {
            e.target.click();
        }
    }

    render() {
        const { isDesktop } = this.props;

        const sidebarSettings = {
            dots: false,
            infinite: true,
            vertical: true,
            focusOnSelect: true,
            centerMode: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            initialSlide: 0,
            speed: 40,
            beforeChange: () => this.beforeAnimation(),
            afterChange: () => this.afterAnimation(),
            responsive: !this.state.isMounted ? [] : [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                        initialSlide: 0,
                        focusOnSelect: true,
                        vertical: false,
                        infinite: true,
                        arrows: true,
                    },
                },
            ],
        };

        const imageSettings = {
            arrows: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            speed: 40,
        };

        const serviceimgStyle = {
            backgroundImage: `url(${serviceSmall})`,
        };

        const innovationimgStyle = {
            backgroundImage: `url(${innovationSmall})`,
        };

        const inspirationimgStyle = {
            backgroundImage: `url(${inspirationSmall})`,
        };

        const ownershipimgStyle = {
            backgroundImage: `url(${ownershipSmall})`,
        };

        const agilityimgStyle = {
            backgroundImage: `url(${agilitySmall})`,
        };

        const collaborationimgStyle = {
            backgroundImage: `url(${collaborationSmall})`,
        };

        const perspectiveimgStyle = {
            backgroundImage: `url(${perspectiveSmall})`,
        };

        const peopleimgStyle = {
            backgroundImage: `url(${peopleSmall})`,
        };

        const integrityimgStyle = {
            backgroundImage: `url(${integritySmall})`,
        };

        return (
            <section className="section value-carousel-section">
                <div className="container">
                    <div className="columns is-multiline is-desktop">
                        <div className="column">
                            <div className="value-carousel-block-wrapper">
                                <div className="columns is-mobile">
                                    <div className="column is-10-tablet is-offset-1-tablet">
                                        <div className="text-content animated fadeInRight">
                                            <div className="big-title font-ff-din-pro color-darkblue">
                                                    Our Values Infuse<br />
                                                    Everything we do
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns is-multiline grid-holder">
                                <div className={`column sidebar-controls column is-12-mobile is-12-tablet is-offset-1-desktop is-3-desktop bold-medium-text ${isDesktop ? '':'mobile-slider-vc'}`}>
                                    <Slider key={this.state.isMounted ? 'client' : 'server'} asNavFor={this.state.sidebarLeft} ref={slider => (this.slider2 = slider)} {...sidebarSettings}>
                                        <div key="roll1" onFocus={(e) => this.onHoverHandler(e)} onMouseOver={(e) => this.onHoverHandler(e)}>
                                            <div className={`${isDesktop ? '':'mobile-text-wrapper'}`}>
                                                <p className="customPaging">1 / 5</p>
                                                <h4 className="first">REIMAGINE THE POSSIBILITIES
                                                    <span className="barline"></span>
                                                    <p className='valueCopy'>
                                                        Be brave. Be bold. Be original. Anticipate what’s next and seek out innovation. Dream big and move fast. Make it happen.
                                                    </p>
                                                </h4>
                                            </div>
                                        </div>
                                        <div key="roll2" onFocus={(e) => this.onHoverHandler(e)} onMouseOver={(e) => this.onHoverHandler(e)}>
                                            <div className={`${isDesktop ? '':'mobile-text-wrapper'}`}>
                                                <p className="customPaging">2 / 5</p>
                                                <h4 className="first">BUILD IT TOGETHER
                                                    <span className="barline"></span>
                                                    <p className='valueCopy'>
                                                        Ground success in collaboration. Feed creativity with diversity and inclusivity. Invest in people.
                                                    </p>
                                                </h4>
                                            </div>
                                        </div>
                                        <div key="roll3" onFocus={(e) => this.onHoverHandler(e)} onMouseOver={(e) => this.onHoverHandler(e)}>
                                            <div className={`${isDesktop ? '':'mobile-text-wrapper'}`}>
                                                <p className="customPaging">3 / 5</p>
                                                <h4 className="first">ACT LIKE YOU OWN IT
                                                    <span className="barline"></span>
                                                    <p className='valueCopy'>
                                                        Think long term and deliver the best. Channel your inner entrepreneur and be accountable for your own success. Remember to lead is to serve.
                                                    </p>
                                                </h4>
                                            </div>
                                        </div>
                                        <div key="roll4" onFocus={(e) => this.onHoverHandler(e)} onMouseOver={(e) => this.onHoverHandler(e)}>
                                            <div className={`${isDesktop ? '':'mobile-text-wrapper'}`}>
                                                <p className="customPaging">4 / 5</p>
                                                <h4 className="first">ADAPT WITH PURPOSE
                                                    <span className="barline"></span>
                                                    <p className='valueCopy'>
                                                        Be agile and expect the unexpected. Rethink roadblocks and expand your parameters. Recognize the journey is the reward and enjoy the ride.
                                                    </p>
                                                </h4>
                                            </div>
                                        </div>
                                        <div key="roll5" onFocus={(e) => this.onHoverHandler(e)} onMouseOver={(e) => this.onHoverHandler(e)}>
                                            <div className={`${isDesktop ? '':'mobile-text-wrapper'}`}>
                                                <p className="customPaging">5 / 5</p>
                                                <h4 className="first">LEAD WITH HUMANITY
                                                    <span className="barline"></span>
                                                    <p className='valueCopy'>
                                                        Keep it humble. Show up with integrity. Do right by our teams, our tenants and clients, our communities and our planet.
                                                    </p>
                                                </h4>
                                            </div>
                                        </div>
                                        
                                    </Slider>
                                </div>
                                <div className="column gallery-sync is-12-mobile is-two-third-desktop">
                                    <Slider key={this.state.isMounted ? 'client' : 'server'} asNavFor={this.state.rightBlock} ref={slider => (this.slider1 = slider)} {...imageSettings}>
                                        <div className="giration" key="gir1">
                                            <div className="columns">
                                                <div className="column is-12-mobile is-12-tablet is-12-desktop">
                                                    <div className="columns image-container">
                                                        <ClientAnimated isMounted={this.state.isMounted} animationIn="fadeInLeft" animationOut="fadeOut" animationInDelay={500} isVisible={this.state.isVisible}>
                                                            <ParallaxImage
                                                                image={serviceBig}
                                                                className="is-2-3 svg-yellow-triangle top-left-ver special-case"
                                                                wrapperClassName="column is-8-mobile column is-7-tablet is-6-desktop"
                                                            />
                                                        </ClientAnimated>
                                                        <div className="image-small column is-8-mobile is-8-tablet is-8-desktop left">
                                                            <div className="image-small-wrapper">
                                                                <div className="ratio is-3-2">
                                                                    <div className="content">
                                                                        <ClientAnimated isMounted={this.state.isMounted} animationIn="fadeInLeft" animationOut="fadeOut" animationInDelay={600} isVisible={this.state.isVisible}>
                                                                            <div className="asset-container" style={serviceimgStyle} />
                                                                        </ClientAnimated>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="giration" key="gir2">
                                            <div className="columns">
                                                <div className="column is-12-mobile is-12-tablet is-12-desktop">
                                                    <div className="columns image-container">
                                                        <ClientAnimated isMounted={this.state.isMounted} animationIn="fadeInLeft" animationOut="fadeOut" animationInDelay={500} isVisible={this.state.isVisible}>
                                                            <ParallaxImage
                                                                image={innovationBig}
                                                                className="is-2-3 svg-yellow-triangle top-left-ver"
                                                                wrapperClassName="column is-8-mobile column is-7-tablet is-6-desktop"
                                                            />
                                                        </ClientAnimated>
                                                        <div className="image-small column is-8-mobile is-8-tablet is-8-desktop left">
                                                            <div className="image-small-wrapper">
                                                                <div className="ratio is-3-2">
                                                                    <div className="content">
                                                                        <ClientAnimated isMounted={this.state.isMounted} animationIn="fadeInLeft" animationOut="fadeOut" animationInDelay={600} isVisible={this.state.isVisible}>
                                                                            <div className="asset-container" style={innovationimgStyle} />
                                                                        </ClientAnimated>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="giration" key="gir3">
                                            <div className="columns">
                                                <div className="column is-12-mobile is-12-tablet is-12-desktop">
                                                    <div className="columns image-container">
                                                        <ClientAnimated isMounted={this.state.isMounted} animationIn="fadeInLeft" animationOut="fadeOut" animationInDelay={500} isVisible={this.state.isVisible}>
                                                            <ParallaxImage
                                                                image={inspirationBig}
                                                                className="is-2-3 svg-yellow-triangle top-left-ver"
                                                                wrapperClassName="column is-8-mobile column is-7-tablet is-6-desktop"
                                                            />
                                                        </ClientAnimated>
                                                        <div className="image-small column is-8-mobile is-8-tablet is-8-desktop left">
                                                            <div className="image-small-wrapper">
                                                                <div className="ratio is-3-2">
                                                                    <div className="content">
                                                                        <ClientAnimated isMounted={this.state.isMounted} animationIn="fadeInLeft" animationOut="fadeOut" animationInDelay={600} isVisible={this.state.isVisible}>
                                                                            <div className="asset-container" style={inspirationimgStyle} />
                                                                        </ClientAnimated>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="giration" key="gir4">
                                            <div className="columns">
                                                <div className="column is-12-mobile is-12-tablet is-12-desktop">
                                                    <div className="columns image-container">
                                                        <ClientAnimated isMounted={this.state.isMounted} animationIn="fadeInLeft" animationOut="fadeOut" animationInDelay={500} isVisible={this.state.isVisible}>
                                                            <ParallaxImage
                                                                image={ownershipBig}
                                                                className="is-2-3 svg-yellow-triangle top-left-ver"
                                                                wrapperClassName="column is-8-mobile column is-7-tablet is-6-desktop"
                                                            />
                                                        </ClientAnimated>
                                                        <div className="image-small column is-8-mobile is-8-tablet is-8-desktop left">
                                                            <div className="image-small-wrapper">
                                                                <div className="ratio is-3-2">
                                                                    <div className="content">
                                                                        <ClientAnimated isMounted={this.state.isMounted} animationIn="fadeInLeft" animationOut="fadeOut" animationInDelay={600} isVisible={this.state.isVisible}>
                                                                            <div className="asset-container" style={ownershipimgStyle} />
                                                                        </ClientAnimated>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="giration" key="gir5">
                                            <div className="columns">
                                                <div className="column is-12-mobile is-12-tablet is-12-desktop">
                                                    <div className="columns image-container">
                                                        <ClientAnimated isMounted={this.state.isMounted} animationIn="fadeInLeft" animationOut="fadeOut" animationInDelay={500} isVisible={this.state.isVisible}>
                                                            <ParallaxImage
                                                                image={agilityBig}
                                                                className="is-2-3 svg-yellow-triangle top-left-ver"
                                                                wrapperClassName="column is-8-mobile column is-7-tablet is-6-desktop"
                                                            />
                                                        </ClientAnimated>
                                                        <div className="image-small column is-8-mobile is-8-tablet is-8-desktop left">
                                                            <div className="image-small-wrapper">
                                                                <div className="ratio is-3-2">
                                                                    <div className="content">
                                                                        <ClientAnimated isMounted={this.state.isMounted} animationIn="fadeInLeft" animationOut="fadeOut" animationInDelay={600} isVisible={this.state.isVisible}>
                                                                            <div className="asset-container" style={agilityimgStyle} />
                                                                        </ClientAnimated>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        
                                        
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

ValuesCarousel.propTypes = {
    isDesktop: PropTypes.bool,
};

export default connect(
    ({ screen }) => ({ isDesktop: screen.isDesktop }),
    null,
)(ValuesCarousel);
